export const LOCAL_STORAGE_ACCESS_TOKEN = 'access_token';
export const LOCAL_STORAGE_REFRESH_TOKEN = 'refresh_token';
